import React from "react"
import {Link} from 'gatsby'

function Nav (props) {

  var firstyear = '2020';
  var academicYear = props.academicYear

  var thisyear = academicYear.slice(academicYear.length - 4)
  var diff = Number(thisyear) - Number(firstyear)

  if(diff > 0) {
    var archivelinks = [];
    for (var i = 0; i < diff; i++) {
      archivelinks.push( (Number(firstyear)-i-1)+'-'+(Number(firstyear)+i));
    }

  }

return (
  <>
    <p>
      <Link to="/">Open Studio {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/drawing/`}>· Drawing {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/graphic-design/`}>· Graphic Design {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/painting/`}>· Painting {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/photography/`}>· Photography {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/printmaking/`}>· Printmaking {academicYear}</Link>
    </p>
    <p className="sub">
      <Link to={`/concentration/${academicYear}/sculpture/`}>· Sculpture {academicYear}</Link>
    </p>
    <p>
      <Link to={`/senior-show/${academicYear}/`}>Senior Show {academicYear}</Link>
    </p>
    <p>
      <Link to={`/bfa-show/${academicYear}/`}>BFA Show {academicYear}</Link>
    </p>

    {archivelinks && (
      <div className="archive">
      <p className="archive-head">Archive</p>

       {archivelinks && archivelinks.map(archivelink => (
          <p className="sub"><Link to={`/open-studio/${archivelink}/`}>· Open Studio {archivelink}</Link></p>
      ))}
      </div>
      )}
    

  </>
)}

export default Nav


